module.exports = __webpack_public_path__ + "img/avatar-4.844f8238.png";